/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * StudentDashboardStyles
 *
 * @file StudentDashboardStyles.jsx
 * @author Mohamed yasar arabath M
 * @since 1.0.0
 */

import { makeStyles } from '@material-ui/core';

const StudentDashboardStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    gap: 16,
    padding: 12,
    maxHeight: 'var(--dashboard-container-max-height)'
  },
  col1: {
    display: 'flex',
    flexGrow: 1,
    scrollbarWidth: 'thin',
    scrollbarColor: '#512EAB26 transparent',
    overflowY: 'auto',

    '&::-webkit-scrollbar': {
      width: 6,
      background: 'transparent'
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#512EAB26',
      borderRadius: 3,
      border: 'none'
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '#512EAB40'
    },
    // Remove scrollbar arrows/buttons
    '&::-webkit-scrollbar-button': {
      display: 'none'
    },
    '&::-webkit-scrollbar-corner': {
      background: 'transparent'
    }
  },
  col2: {
    display: 'flex',
    flexGrow: 2,
    overflowY: 'auto',
    scrollbarWidth: 'thin',
    scrollbarColor: '#512EAB26 transparent',
    backgroundColor: '#fff',
    borderRadius: 8,

    '&::-webkit-scrollbar': {
      width: 6,
      background: 'transparent'
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#512EAB26',
      borderRadius: 3,
      border: 'none'
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '#512EAB40'
    },
    // Remove scrollbar arrows/buttons
    '&::-webkit-scrollbar-button': {
      display: 'none'
    },
    '&::-webkit-scrollbar-corner': {
      background: 'transparent'
    }
  }
}));

// Add styles for StudentDetailsPopup
export const useStudentNeedingSupportStyles = makeStyles(() => ({
  // Add any specific styles needed for the popup here
  popupContainer: {
    padding: '16px'
  }
}));

export default StudentDashboardStyles;
